import React from 'react';
import AnimatedContent from '../blocks/Animations/AnimatedContent/AnimatedContent';
import '../styles/FeatureRow.css';

interface FeatureRowProps {
  image: string;
  alt: string;
  title?: string;
  description: string;
  imageOnLeft?: boolean;
}

const FeatureRow: React.FC<FeatureRowProps> = ({ 
  image, 
  alt, 
  title, 
  description, 
  imageOnLeft = true 
}) => {
  return (
    <div className={`feature-row ${imageOnLeft ? 'image-left' : 'image-right'}`}>
      <AnimatedContent
        distance={100}
        direction="horizontal"
        reverse={!imageOnLeft}
        config={{ tension: 80, friction: 20 }}
        initialOpacity={0.2}
        animateOpacity
        scale={1}
        threshold={0.2}
      >
        <div className="feature-image-container">
          <img src={image} alt={alt} className="feature-image" />
        </div>
      </AnimatedContent>
      
      <AnimatedContent
        distance={100}
        direction="horizontal"
        reverse={imageOnLeft}
        config={{ tension: 80, friction: 20 }}
        initialOpacity={0.2}
        animateOpacity
        scale={1}
        threshold={0.2}
      >
        <div className="feature-content">
          {title && <h3 className="feature-title">{title}</h3>}
          <p className="feature-description">{description}</p>
        </div>
      </AnimatedContent>
    </div>
  );
};

export default FeatureRow; 